import React from 'react';
import { UserProvider } from './UserContext';
import { AppProvider } from './AppContext';
import { ProjectProvider } from './ProjectContext';

const AppProviders = ({ children }) => {
  return (
    <UserProvider>
      <AppProvider>
        <ProjectProvider>{children}</ProjectProvider>
      </AppProvider>
    </UserProvider>
  );
};

export default AppProviders;

